import { useIfpAnalyticsService } from '@sec-loans-ui/ifp-loans/analytics/analyticsContext'
import { FormContext } from '@sec-loans-ui/ifp-loans/steps/formContext'
import { UseWizardFormReturn } from '@ui-common/hooks/useWizardForm'
import { FormStep as CommonFormStep } from '@ui-common/steps/FormStep'
import { LogoIconType, ProgressBarStepProps } from '@ui-components/global/ComponentProps'
import { PropsWithChildren, ReactNode, use } from 'react'
import { FieldValues } from 'react-hook-form'

import { getAnalyticsNameForPage } from '../analytics/service'

export interface StepProps<TFormData extends FieldValues> {
  subHeader: string
  formMethods: UseWizardFormReturn<TFormData>
  onSubmit: () => void
  isLoading?: boolean
  allowBack?: boolean
  submitLabel?: string
  customFooter?: ReactNode
  showIntroSectionDivider?: boolean
  progressBarOptions?: ProgressBarStepProps
  pageNameForAnalytics?: string
}

export const FormStep = <TFormData extends FieldValues>({
  formMethods,
  subHeader,
  onSubmit,
  isLoading = false,
  customFooter,
  children,
  allowBack = true,
  submitLabel,
  showIntroSectionDivider,
  progressBarOptions,
  pageNameForAnalytics,
}: PropsWithChildren<StepProps<TFormData>>) => {
  const { isEditing, step, goBack, exitWithConfirmDialog, goBackToStatus, isStepSubmitting } = use(FormContext)
  const { analyticsService } = useIfpAnalyticsService()

  return (
    <CommonFormStep
      onBackToSummary={goBackToStatus}
      customFooter={customFooter}
      formMethods={formMethods}
      icon={LogoIconType.SPankki}
      isEditing={isEditing}
      isLoading={isLoading || isStepSubmitting}
      onBack={allowBack || isEditing ? goBack : undefined}
      onExit={exitWithConfirmDialog}
      onSubmit={onSubmit}
      shouldShowMainHeader={false}
      stepId={step}
      submitLabelOverride={submitLabel}
      title={''}
      analytics={analyticsService}
      pageNameForAnalytics={pageNameForAnalytics ?? getAnalyticsNameForPage(step)}
      pageIntro={{
        title: subHeader,
        showIntroSectionDivider,
      }}
      hasDataDependencies={false}
      progressBarOptions={progressBarOptions || null}
    >
      {children}
    </CommonFormStep>
  )
}
